import Vue from 'vue'

Vue.mixin({
  methods: {
    isAdmin() {
      return this.$store.state.app.account.is_admin === true;
    },
    isLogged() {
      return this.$store.state.app.account.id !== null;
    }
  }
})



// WEBPACK FOOTER //
// ./src/mixins.js